import React, { Fragment } from "react";
import { eyeColor, rotate } from "../../nodevn/ultil";
import compose from 'recompose/compose'
import optionCallback from "../optionCallback";

import Base from './Pattern1';
import Pattern1 from './Pattern1';
import Pattern2 from './Pattern2';
import Pattern3 from './Pattern3';
import Pattern4 from './Pattern4';
import Pattern5 from './Pattern5';
import Pattern6 from './Pattern6';
import Pattern7 from './Pattern7';
import Pattern8 from './Pattern8';
import Pattern9 from './Pattern9';
import Pattern10 from './Pattern10';
import Pattern11 from './Pattern11';
import Pattern12 from './Pattern12';
import Pattern13 from './Pattern13';
import Pattern14 from './Pattern14';
import Pattern15 from './Pattern15';
import Pattern16 from './Pattern16';
import Pattern17 from './Pattern17';
import Pattern18 from './Pattern18';


function render({ source, transform, ...options}: any){
	const { color, data, transform : trans }: any = source || {};
	const attr = eyeColor({...options, color });
	return rotate(<Fragment>{data}</Fragment>, trans, transform, attr)
}

export default compose(
	optionCallback('pattern', 'pattern0', Pattern1, { render }),
	optionCallback('pattern', 'pattern1', Pattern2, { render, "transform": { "tl": 270, "tr": 0, "bl": 180, "br": 90 } }),
	optionCallback('pattern', 'pattern2', Pattern3, { render, "transform": { "tl": 90, "tr": 0, "bl":0, "br": 90 } }),
	optionCallback('pattern', 'pattern3', Pattern4, { render, "transform": { "tl": 90, "tr": 180, "bl":0, "br": 270 } }),
	optionCallback('pattern', 'pattern4', Pattern5, { render }),
	optionCallback('pattern', 'pattern5', Pattern6, { render, "transform": { "tl": 270, "tr": 0, "bl": 180, "br": 90 } }),
	optionCallback('pattern', 'pattern6', Pattern7, { render }),
	optionCallback('pattern', 'pattern7', Pattern8, { render }),
	optionCallback('pattern', 'pattern8', Pattern9, { render }),
	optionCallback('pattern', 'pattern9', Pattern10, { render }),
	optionCallback('pattern', 'pattern10', Pattern11, { render }),
	optionCallback('pattern', 'pattern11', Pattern12, { render }),
	optionCallback('pattern', 'pattern12', Pattern13, { render }),
	optionCallback('pattern', 'pattern13', Pattern14, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 } }),
	optionCallback('pattern', 'pattern14', Pattern15, { render }),
	optionCallback('pattern', 'pattern15', Pattern16, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 } }),
	optionCallback('pattern', 'pattern16', Pattern17, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 } }),
	optionCallback('pattern', 'pattern17', Pattern18, { render, "transform": { "tl": 0, "tr": 90, "bl": 270, "br": 180 } }),
	optionCallback('pattern', 'default', Base, { render }) // default phải luôn ở cuối
)